import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import App from './components/App';

/**
 * @param {Object} store
 * @param {HTMLElement} element
 * @return {Object}
 */
export default (store, element) => {
    const root = createRoot(element);

    root.render(
        <Provider store={store}>
            <App inModal={false} />
        </Provider>,
    );

    return {
        /** @var {function} - unmounts the react app. */
        unmount: () => root.unmount(),
    };
};
